import { handleError } from '../utils/errorHandler';
import { sanitizeInput } from '../utils/sanitizeInput';
import React, { useState, useEffect } from 'react';
import { API_URL, COLOR_FONT_TITLE } from '../Config';
import { apiFetch } from '../apiClient';
import { } from '../Transversal';
import { DEFAULT_FILTER, ArcFiltros } from './SesionDetalles';
import { FaSort, FaDownload, FaEraser, FaArrowLeft } from 'react-icons/fa';
import { useUrlParams } from '../hooks/useUrlParams';

interface HeaderProps {
    onFilterChange: (filtrar: number) => void;
    codigoDivipola: string;
    visibleFilters: string[]; // New property to indicate visible filters
    onToggleDetalles: (id: any) => void;
    indicador: any
}

class DivipolaCantidad {
    public codigoDivipola: string = "";
    public nombre: string = "";
    public cantidad: number = 0;
    public cantidadGlobal: number = 0;
}

let divipolaCantidad: DivipolaCantidad[] = [];

let currentYear = 0;
let filterIndicador = "";
let listaDesagregacion: ArcDesagregacion[] = [];
const meses: string[] = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
    "enero - marzo",
    "abril - junio",
    "julio - septiembre",
    "enero - diciembre"
];

const HeaderDetalles: React.FC<HeaderProps> = ({ onFilterChange, visibleFilters, codigoDivipola, onToggleDetalles, indicador }) => {
    const [filtros, setFiltros] = useState<FiltroLista[]>([]);
    const [mostrarBoton, setMostrarBoton] = useState(true);

    // Capturar parámetros de URL
    const { primeraInfancia: primeraInfanciaParam } = useUrlParams();

    useEffect(() => {

        const params = new URLSearchParams(window.location.search);
        const detailsParam = params.get("details");
        if (detailsParam === "true") {
            setMostrarBoton(false);
        }

        const currentYear = new Date().getFullYear();
        console.log(indicador);
        getFiltros(currentYear.toString());
    }, [indicador]);

    const fetchDatos = async () => {
        try {
            DEFAULT_FILTER.anio = indicador.anio;
            DEFAULT_FILTER.tipoClasificador = indicador.tipoClasificador;
            DEFAULT_FILTER.indicador = indicador.indicador;
            DEFAULT_FILTER.tipoValor = indicador.tipoValor;
            DEFAULT_FILTER.entidad = indicador.entidad;
            DEFAULT_FILTER.tipoClasificador = indicador.tipoClasificador;
            DEFAULT_FILTER.idVariable = indicador.idVariable;
            DEFAULT_FILTER.idTipoValor = indicador.idTipoValor;
            DEFAULT_FILTER.esPDET = indicador.capaPDETActiva;
            DEFAULT_FILTER.codigoDivipolaDpto = indicador.codigoDivipolaDpto;
            DEFAULT_FILTER.codigoDivipolaMpio = indicador.codigoDivipolaMpio;
            DEFAULT_FILTER.codigoDivipolaPdetRegion = indicador.codigoDivipolaPdetRegion;
            DEFAULT_FILTER.codigoDivipolaPdetMunicipio = indicador.codigoDivipolaPdetMunicipio;
            //originales
            DEFAULT_FILTER.originalAnio = DEFAULT_FILTER.anio;
            DEFAULT_FILTER.originalCodigoDivipolaPdetRegion = indicador.codigoDivipolaPdetRegion;
            DEFAULT_FILTER.originalCodigoDivipolaPdetMunicipio = indicador.codigoDivipolaPdetMunicipio;
            DEFAULT_FILTER.originalCodigoDivipolaDpto = indicador.codigoDivipolaDpto;
            DEFAULT_FILTER.originalCodigoDivipolaMpio = indicador.codigoDivipolaMpio;
            //DEFAULT_FILTER.originalPeriodo = DEFAULT_FILTER.periodo;
            DEFAULT_FILTER.originalEsPDET = DEFAULT_FILTER.esPDET;
            //----------------
            DEFAULT_FILTER.regrescarFiltros++;

            const queryString = Object.keys(DEFAULT_FILTER)
                .filter(key => DEFAULT_FILTER[key as keyof ArcFiltros] !== undefined)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros] ?? '')}`)
                .join('&');

            let url = `${API_URL}/ArcIndicador/GetDivipolaCantidades?${queryString}`
            let response2 = await apiFetch(url);
            let data2 = await response2.json();
            divipolaCantidad.length = 0;
            divipolaCantidad.push(...data2);
            divipolaCantidad = divipolaCantidad.filter((divipola) => divipola.codigoDivipola !== 'TOTAL');
            //filtros
            url = `${API_URL}/ArcIndicador/GetFiltros?${queryString}`
            let response = await apiFetch(url);
            let data = await response.json();


            /*
            let queryString = Object.keys(DEFAULT_FILTER)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros])}`)
                .join('&');
            const url = `${API_URL}/ArcIndicador/GetFiltros?${queryString}`
            const response = await fetch(url);
            const data = await response.json();
            */
            setFiltros(data);
        } catch (error) {
            handleError(error);
        }
    };

    const getFiltros = async (anio: string) => {
        if (indicador == "") {
            return;
        }
        /*
        if (indicador == filterIndicador && indicador != "" && DEFAULT_FILTER.anio == anio) {
            DEFAULT_FILTER.regrescarFiltros++;
            onFilterChange(DEFAULT_FILTER.regrescarFiltros);
            return;
        }
        */
        DEFAULT_FILTER.anio = anio;
        filterIndicador = indicador;
        currentYear = Number(DEFAULT_FILTER.anio);
        await fetchDatos();
    };

    const handleFilterChange = (field: string) => (event: React.ChangeEvent<HTMLSelectElement>) => {
        DEFAULT_FILTER.regrescarFiltros++;
        // Sanear la entrada del usuario para prevenir XSS/content spoofing
        const sanitizedValue = sanitizeInput(event.target.value);

        if (field.toLowerCase() === 'anio') {
            currentYear = Number(sanitizedValue);
            indicador.anio = currentYear.toString();
            DEFAULT_FILTER.anio = currentYear.toString();
        }
        if (field.toLowerCase() === 'tipoclasificador') {
            DEFAULT_FILTER.tipoClasificador = sanitizedValue;
        }
        if (field.toLowerCase() === 'divipolapdetregion') {
            DEFAULT_FILTER.codigoDivipolaPdetRegion = sanitizedValue;
            DEFAULT_FILTER.codigoDivipolaDpto = "";
            DEFAULT_FILTER.codigoDivipolaPdetMunicipio = "";
            DEFAULT_FILTER.codigoDivipolaMpio = "";
            indicador.codigoDivipolaPdetRegion = sanitizedValue;
        }
        if (field.toLowerCase() === 'divipolapdetmunicipio') {
            DEFAULT_FILTER.codigoDivipolaPdetMunicipio = sanitizedValue;
            DEFAULT_FILTER.codigoDivipolaMpio = sanitizedValue;
            indicador.codigoDivipolaPdetMunicipio = sanitizedValue;
        }
        if (field.toLowerCase() === 'divipolapdetdepartamento') {
            DEFAULT_FILTER.codigoDivipolaDpto = sanitizedValue;
            DEFAULT_FILTER.codigoDivipolaMpio = "";
            indicador.codigoDivipolaDpto = sanitizedValue
        }
        if (field.toLowerCase() === 'divipoladpto') {
            DEFAULT_FILTER.codigoDivipolaDpto = sanitizedValue;
            DEFAULT_FILTER.codigoDivipolaMpio = "";
            indicador.codigoDivipolaDpto = sanitizedValue
        }
        if (field.toLowerCase() === 'divipolampio') {
            DEFAULT_FILTER.codigoDivipolaMpio = sanitizedValue;
            indicador.codigoDivipolaMpio = sanitizedValue
            indicador.codigoDivipolaDpto = DEFAULT_FILTER.codigoDivipolaDpto            
        }
        if (field.toLowerCase() === 'sector') {
            DEFAULT_FILTER.sector = sanitizedValue;
        }
        if (field.toLowerCase() === 'entidad') {
            DEFAULT_FILTER.entidad = sanitizedValue;
        }
        if (field.toLowerCase() === 'periodo') {
            DEFAULT_FILTER.periodo = sanitizedValue;
        }

        DEFAULT_FILTER.regrescarFiltros++;
        getFiltros(currentYear.toString());

        DEFAULT_FILTER.IsFilter=true;
        onFilterChange(DEFAULT_FILTER.regrescarFiltros);
    };

    const GetArcDesagregacion = async () => {
        try {
            let queryString = Object.keys(DEFAULT_FILTER)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros])}`)
                .join('&');
            const url = `${API_URL}/ArcIndicador/GetArcDesagregacion?${queryString}`
            const response = await fetch(url);
            const data = await response.json();
            const grillaConIds = data.map((row: any) => ({
                ...row,
                tipoClasificador: (() => {
                    switch (row.tipoClasificador) {
                        case "PND":
                            return "PND - Plan Nacional de Desarrollo";
                        case "PMI":
                            return "PMI - Plan Marco de Implementación";
                        case "PNS":
                            return "PNRRI - Planes Nacionales de la Reforma Rural Integral";
                        case "PMI, PNS":
                            return "PMI, PNRRI";
                        default:
                            return row.tipoClasificador;
                    }
                })()
            }));
            listaDesagregacion = grillaConIds;
            downloadExcel();
        } catch (error) {
            handleError(error);
        }
    };

    const downloadExcel = () => {
        const XLSX = require('xlsx');
        const filteredGrilla = listaDesagregacion.map(({
            //id, 
            tipoClasificador,
            //idVariable, 
            //idTipoValor, 
            anio, periodo,
            //idCargue, 
            codigoDivipola, departamentoMunicipio, datoDepartamentalMunicipal, datoUrbano, datoRural, masculino, femenino, noBinario, noResponde, orientacionesSexualesEIdentidadesDeGeneroDiversas, primeraInfancia05Anios, infancia611Anios, adolescencia1217, juventud1828, adultez2959, personaMayor60, comunidadesNegrasAfrocolombianasRaizalesPalenqueras, poblacionIndigena, puebloRrom, personasCampesinas, personasConDiscapacidad, victimas, personaEnProcesoDeReincorporacion, personasDefensorasLideresSociales
            //fechaReporte, esPdet
        }) => ({
            //"ID": id,
            "Tipo Clasificador": tipoClasificador,
            //"ID Variable": idVariable,
            //"ID Tipo Valor": idTipoValor,
            "Año": anio,
            "Periodo": periodo,
            //"ID Cargue": idCargue,
            "Código Divipola": codigoDivipola,
            "Departamento/Municipio": departamentoMunicipio,
            "Dato Departamental/Municipal": datoDepartamentalMunicipal,
            "Dato Urbano": datoUrbano,
            "Dato Rural": datoRural,
            "Masculino": masculino,
            "Femenino": femenino,
            "No Binario": noBinario,
            "No Responde": noResponde,
            "Orientaciones Sexuales e Identidades de Género Diversas": orientacionesSexualesEIdentidadesDeGeneroDiversas,
            "Primera Infancia (0-5 Años)": primeraInfancia05Anios,
            "Infancia (6-11 Años)": infancia611Anios,
            "Adolescencia (12-17 Años)": adolescencia1217,
            "Juventud (18-28 Años)": juventud1828,
            "Adultez (29-59 Años)": adultez2959,
            "Persona Mayor (60+)": personaMayor60,
            "Comunidades Negras, Afrocolombianas, Raizales y Palenqueras": comunidadesNegrasAfrocolombianasRaizalesPalenqueras,
            "Población Indígena": poblacionIndigena,
            "Pueblo Rrom": puebloRrom,
            "Personas Campesinas": personasCampesinas,
            "Personas con Discapacidad": personasConDiscapacidad,
            "Víctimas": victimas,
            "Persona en Proceso de Reincorporación": personaEnProcesoDeReincorporacion,
            "Personas Defensoras y Líderes Sociales": personasDefensorasLideresSociales,
            //"Fecha Reporte": fechaReporte,
            //"Es PDET": esPdet
        }));
        const worksheet = XLSX.utils.json_to_sheet(filteredGrilla);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Desagregaciones');
        const filtrosSeleccionados = Object.keys(DEFAULT_FILTER)
            .filter(key => {
                const value = DEFAULT_FILTER[key as keyof ArcFiltros];
                return value !== "" && (typeof value !== 'number' || value > 0);
            })
            .map(key => `${key}-${DEFAULT_FILTER[key as keyof ArcFiltros]}`)
            .join('_');
        let nombreArchivo = `barras_${DEFAULT_FILTER.anio}_${filtrosSeleccionados}.xlsx`;
        if (nombreArchivo.length >= 200) {
            nombreArchivo = nombreArchivo.substring(0, 190) + '.xlsx';
        }
        XLSX.writeFile(workbook, nombreArchivo);
    };

    const createFilter = (field: string, defaultValue: string = "", width: string = "auto", label: string = "", parentValue: string = "", requieredParent: boolean = false, tooltip: string = "") => {
        try {
            // Si es tipoclasificador y primerainfancia=1, mostrar solo un label fijo
            if (field.toLowerCase() === 'tipoclasificador' && primeraInfanciaParam) {
                return (
                    <div style={{ float: "left", width: width, marginRight: "0px" }} title={tooltip}>
                        {label && (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <label style={{ fontSize: '12px', color: COLOR_FONT_TITLE }}>{label}</label>
                                {tooltip && <span style={{ fontSize: '10px', color: 'gray', marginLeft: '0px' }}>{tooltip}</span>}
                            </div>
                        )}
                        <div style={{ width: "100%" }}>
                            <div style={{ 
                                float: "left", 
                                minWidth: "50px", 
                                width: "91%", 
                                fontSize: '12px', 
                                color: 'black',
                                padding: '0px 4px',
                                border: '1px solid #ffffff',
                                borderRadius: '4px',
                                backgroundColor: '#ffffff',
                                fontWeight: 'normal'
                            }}>
                                Tablero de control de las Políticas de Primera Infancia, Infancia, Adolescencia y Familias
                            </div>
                        </div>
                    </div>
                );
            }

            let filteredValues = filtros
                .filter(filtro => filtro.nombre == field && filtro.padre == parentValue)
                .map(filtro => ({ valor: filtro.valor, texto: filtro.texto }))
                .filter((value, index, self) => self.findIndex(v => v.valor === value.valor) === index)
            if (field.toLowerCase() === 'divipolapdetmunicipio') {
                //remove in filteredValues if not int  divipolaCantidad
                console.log('filteredValues(0)', filteredValues);
                filteredValues = filteredValues.filter(value =>
                    divipolaCantidad.some(d => d.codigoDivipola === value.valor)
                );
                console.log('filteredValues(1)', filteredValues);
            }
            if (field.toLowerCase() === 'divipolappto') {
                //remove in filteredValues if not int  divipolaCantidad
                console.log('filteredValues(0)', filteredValues);
                filteredValues = filteredValues.filter(value =>
                    divipolaCantidad.some(d => d.codigoDivipola === value.valor)
                );
                console.log('filteredValues(1)', filteredValues);                 
            }
            if (field.toLowerCase() === 'periodo') {
                const sortedValues = filteredValues.sort((a, b) => {
                    const indexA = meses.indexOf(a.texto.toLowerCase());
                    const indexB = meses.indexOf(b.texto.toLowerCase());
                    return indexA - indexB;
                });
                if (!defaultValue && sortedValues.length > 0) {
                    defaultValue = sortedValues[sortedValues.length - 1].valor;
                    DEFAULT_FILTER.originalPeriodo = defaultValue;
                }
            }
            else {
                //filteredValues.sort((a, b) => a.valor.localeCompare(b.valor));
                filteredValues.sort((a, b) => a.texto.localeCompare(b.texto));
            }

            const isDisabled = requieredParent && !parentValue;
            const clearFilter = () => {
                handleFilterChange(field)({ target: { value: "" } } as React.ChangeEvent<HTMLSelectElement>);
            };

            return (
                <div style={{ float: "left", width: width, marginRight: "5px" }} title={tooltip}>
                    {label && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <label style={{ fontSize: '12px', color: COLOR_FONT_TITLE }}>{label}</label>
                            {tooltip && <span style={{ fontSize: '10px', color: 'gray', marginLeft: '0px' }}>{tooltip}</span>}
                        </div>
                    )}
                    <div style={{ width: "100%" }}>
                        <select onChange={handleFilterChange(field)} style={{ float: "left", minWidth: "50px", width: "91%", fontSize: '12px', color: 'black' }} disabled={isDisabled} value={defaultValue}>
                            {(field.toLowerCase() !== 'anio' && field.toLowerCase() !== 'periodo') && <option value="">Todos</option>}
                            {filteredValues.map(({ valor, texto }) => (
                                <option key={valor} value={valor}>
                                    {texto}
                                </option>
                            ))}
                        </select>
                        {defaultValue && (field.toLowerCase() !== 'anio' && field.toLowerCase() !== 'periodo') && (
                            <button onClick={clearFilter} style={{ float: "left", fontSize: '12px', border: 'none', background: 'none', cursor: 'pointer', color: "#cccccc" }}>X</button>
                        )}
                    </div>
                </div>
            );
        } catch (error) {
            handleError(error);
            return null;
        }
    };

    let withColumn = "23%";
    if (DEFAULT_FILTER.esPDET == "1") {
        withColumn = "20%";
    }

    return (
        <header style={{ height: "auto", backgroundColor: "#f8f9fa", display: "flex", flexDirection: "column", alignItems: "left", justifyContent: "space-between", padding: "10px" }}>
            <div style={{ backgroundColor: "white", padding: "10px", marginBottom: "10px" }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ fontSize: '16px', width: 140, color: COLOR_FONT_TITLE }}><b>Indicador{'>>'}</b></div>
                    <div id="resto" style={{ fontSize: '16px', flex: 1 }}>
                        <div><b>{indicador.codigo}</b>: {indicador.indicador}</div>
                        {indicador.tipoClasificador !== 'PND' && (
                            <div><strong>Acción territorial monitoreada:</strong> {indicador.tipoValor}</div>
                        )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <button style={{ border: 'none', background: 'none' }} onClick={() => {
                            GetArcDesagregacion();
                        }}>
                            <FaDownload color={COLOR_FONT_TITLE} />
                        </button>
                    </div>
                </div>
            </div>
            <div style={{ height: "auto", backgroundColor: "#f8f9fa", display: "flex", flexDirection: "column", alignItems: "left", justifyContent: "space-between", padding: "10px" }}>
                <div style={{ justifyContent: "left" }}>
                    {visibleFilters.includes("Anio") && createFilter("Anio", DEFAULT_FILTER.anio, "70px", "Año", "", false, "")}
                    {visibleFilters.includes("Periodo") && createFilter("Periodo", DEFAULT_FILTER.periodo, "120px", "Periodo", "", false, "")}
                    {DEFAULT_FILTER.esPDET == "1" && visibleFilters.includes("DivipolaPdetRegion") && createFilter("DivipolaPdetRegion", DEFAULT_FILTER.codigoDivipolaPdetRegion, withColumn, "Region Pdet:", "", false, "")}
                    {DEFAULT_FILTER.esPDET == "" && visibleFilters.includes("DivipolaDpto") && createFilter("DivipolaDpto", DEFAULT_FILTER.codigoDivipolaDpto, withColumn, "Departamento", "", false, "")}
                    {DEFAULT_FILTER.esPDET == "1" && visibleFilters.includes("DivipolaPdetDepartamento") && createFilter("DivipolaPdetDepartamento", DEFAULT_FILTER.codigoDivipolaDpto, withColumn, "Dpto Pdet:", DEFAULT_FILTER.codigoDivipolaPdetRegion, false, "seleccione región")}
                    {DEFAULT_FILTER.esPDET == "" && visibleFilters.includes("DivipolaMpio") && createFilter("DivipolaMpio", DEFAULT_FILTER.codigoDivipolaMpio, withColumn, "Municipio", DEFAULT_FILTER.codigoDivipolaDpto, true, "Seleccione dpto")}
                    {DEFAULT_FILTER.esPDET == "1" && visibleFilters.includes("DivipolaPdetMunicipio") && createFilter("DivipolaPdetMunicipio", DEFAULT_FILTER.codigoDivipolaPdetMunicipio, withColumn, "Mpio Pdet", DEFAULT_FILTER.codigoDivipolaDpto, false, "Seleccione dpto")}

                    <button
                        onClick={() => {
                            indicador.codigoDivipolaMpio = "";
                            indicador.codigoDivipolaDpto = "";
                            limpiarFiltros();
                            handleFilterChange("DivipolaDpto")({ target: { value: "" } } as React.ChangeEvent<HTMLSelectElement>);
                            //handleFilterChange("DivipolaMpio")({ target: { value: "" } } as React.ChangeEvent<HTMLSelectElement>);
                            onFilterChange(DEFAULT_FILTER.regrescarFiltros);
                        }}
                        style={{
                            marginTop: 18,
                            fontSize: '14px',
                            padding: '5px 10px 5px 10px',
                            cursor: 'pointer',
                            height: '30px',
                            border: '1px solid gray',
                            borderRadius: '5px',
                            backgroundColor: '#919191',
                            transition: '.5ms',
                            fontFamily: 'WorkSans, Arial, sans-serif',
                            lineHeight: '1.2rem',
                            fontWeight: 500,
                            letterSpacing: '.8px',
                            color: '#fff'
                        }}>
                        <FaEraser /> Limpiar búsqueda
                    </button>

                    {mostrarBoton && (
  <button
    onClick={() => {
        indicador.codigoDivipolaMpio = "";
        indicador.codigoDivipolaDpto = "";
        limpiarFiltros();
        handleFilterChange("DivipolaDpto")({ target: { value: "" } } as React.ChangeEvent<HTMLSelectElement>);
       // handleFilterChange("DivipolaMpio")({ target: { value: "" } } as React.ChangeEvent<HTMLSelectElement>);
        onToggleDetalles("");
    }}
    style={{
      marginTop: 18,
      float: 'right',
      fontSize: '14px',
      padding: '5px 0px 5px 6px',
      cursor: 'pointer',
      height: '30px',
      width: '30px',
      border: '1px solid gray',
      borderRadius: '50px',
      backgroundColor: '#36c',
      transition: '.5ms',
      fontFamily: 'WorkSans, Arial, sans-serif',
      lineHeight: '1.2rem',
      fontWeight: 500,
      letterSpacing: '.8px',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <FaArrowLeft style={{ marginRight: '5px', color: 'white' }} />
  </button>
)}
                </div>
            </div>

        </header>
    );
};

export const limpiarFiltros = () => {
    DEFAULT_FILTER.anio = DEFAULT_FILTER.originalAnio;
    DEFAULT_FILTER.codigoDivipolaPdetRegion = DEFAULT_FILTER.originalCodigoDivipolaPdetRegion;
    DEFAULT_FILTER.codigoDivipolaPdetMunicipio = DEFAULT_FILTER.originalCodigoDivipolaPdetMunicipio;
    DEFAULT_FILTER.codigoDivipolaDpto = DEFAULT_FILTER.originalCodigoDivipolaDpto;
    DEFAULT_FILTER.codigoDivipolaMpio = DEFAULT_FILTER.originalCodigoDivipolaMpio;
    DEFAULT_FILTER.esPDET = DEFAULT_FILTER.originalEsPDET;
    DEFAULT_FILTER.sector = "";
    DEFAULT_FILTER.entidad = "";
    DEFAULT_FILTER.periodo = "";
    DEFAULT_FILTER.regrescarFiltros++;    
       
    //filtro Periodo select  DEFAULT_FILTER.periodo, el select tiene un id="Periodo"
    const periodo = document.getElementById("Periodo") as HTMLSelectElement;
    if (periodo) {
        periodo.value = DEFAULT_FILTER.originalPeriodo;
    }
}

class FiltroLista {
    public nombre: string = "";
    public valor: string = "";
    public texto: string = "";
    public padre: string = "";
    public orden: number = 0;
}

class ArcDesagregacion {
    public id: number = 0;
    public tipoClasificador: string = "";
    public idVariable: number = 0;
    public idTipoValor: number = 0;
    public anio: number = 0;
    public periodo: string = "";
    public idCargue: number = 0;
    public codigoDivipola: string = "";
    public departamentoMunicipio: string = "";
    public datoDepartamentalMunicipal?: number = 0;
    public datoUrbano?: number = 0;
    public datoRural?: number = 0;
    public masculino?: number = 0;
    public femenino?: number = 0;
    public noBinario?: number = 0;
    public noResponde?: number = 0;
    public orientacionesSexualesEIdentidadesDeGeneroDiversas?: number = 0;
    public primeraInfancia05Anios?: number = 0;
    public infancia611Anios?: number = 0;
    public adolescencia1217?: number = 0;
    public juventud1828?: number = 0;
    public adultez2959?: number = 0;
    public personaMayor60?: number = 0;
    public comunidadesNegrasAfrocolombianasRaizalesPalenqueras?: number = 0;
    public poblacionIndigena?: number = 0;
    public puebloRrom?: number = 0;
    public personasCampesinas?: number = 0;
    public personasConDiscapacidad?: number = 0;
    public victimas?: number = 0;
    public personaEnProcesoDeReincorporacion?: number = 0;
    public personasDefensorasLideresSociales?: number = 0;
    public fechaReporte: Date = new Date();
    public esPdet: boolean = false;
}

export default HeaderDetalles;
